import fetch from './fetch'

class LawyerApi {
	public addTask(form: any) {
		return fetch({
			url: 'injury/order/lawsuit/add',
			method: 'post',
			data: form,
			timeout: 60 * 1000,
		})
	}

	public queryRelated(orderNo: any) {
		return fetch({
			url: 'injury/order/lawsuit/queryRelated',
			method: 'post',
			params: {
				orderNo,
			},
		})
	}

	public activeLawyer(form: object) {
		return fetch({
			url: 'injury/visitor/lawyer/active',
			method: 'post',
			data: form,
		})
	}

	public inactiveLawyer(form: object) {
		return fetch({
			url: 'injury/visitor/lawyer/inactive',
			method: 'post',
			data: form,
		})
	}

	public getList(form: any) {
		return fetch({
			url: 'injury/lawyer/queryList',
			method: 'post',
			data: form,
		})
	}

	public getOrderList(form: any) {
		return fetch({
			url: 'injury/order/lawyer/orderList',
			method: 'post',
			data: form,
		})
	}

	public exportList(form: any) {
		return fetch({
			url: 'injury/lawyer/export',
			method: 'post',
			data: form,
			timeout: 0,
			responseType: 'blob',
		})
	}

	public getDetail(lawyerId: any) {
		return fetch({
			url: 'injury/lawyer/info',
			method: 'post',
			params: {
				lawyerId,
			},
		})
	}
}

export default new LawyerApi()
